import { skipToken } from "@tanstack/react-query";
import { useCurrentWorkspace } from "@v2/contexts/WorkspaceDashboardContext";
import { workspaceRouter } from "@v2/trpc/routes/workspace";

const useChatMessagesUsage = () => {
  const workspace = useCurrentWorkspace();

  const { data: chatMessagesUsage } =
    workspaceRouter.getChatMessagesUsage.useQuery(
      !workspace?.id ? skipToken : workspace.id,
      {
        enabled: workspace?.paymentProcessor === "stripe",
      },
    );

  return chatMessagesUsage;
};

export default useChatMessagesUsage;
